import React, { useState, useEffect } from "react";
import { storage } from "../../Firebase";
import { ref, uploadBytes, getDownloadURL, listAll, getMetadata } from "firebase/storage";
import { v4 } from "uuid";
import { Gallery } from "../../components/gallery";
import { getFileName } from "../../helper/getFileName";
import { Spinner } from "../../components/spinner";
import { explorer } from "./../../data/folderData";
import { getAllImages } from "../../helper/getAllImages";

function Home() {
  const [uploadImage, setUploadImage] = useState(null);
  const [currentfolder, setCurrentFolder] = useState("");
  const [galleryLoader, setGalleryLoader] = useState(false);
  const [uploadBtn, setUploadBtn] = useState(true);
  const [images, setImages] = useState([]);
  const [imageListRef, setImageListRef] = useState(ref(storage, `${currentfolder}/`));

  const Folderss = ({ explorer }) => {
    const [expand, setExpand] = useState(false);
    useEffect(() => {
      if (explorer.name === "root") {
        setExpand(true);
      }
      if (explorer.name === currentfolder) {
        setExpand(true);
      }
    }, [explorer.name]);
    return (
      <>
        {explorer.isFolder ? (
          <div style={{}}>
            <div
              href={explorer.link}
              title={explorer.name}
              onClick={() => setExpand(!expand)}
              style={{
                display: "flex",
                fontSize: "14px",
                justifyContent: "space-between",
                width: "120px",
                cursor: "pointer",
                background: "gray",
                color: "white",
                margin: 4,
                padding: "4px",
                borderRadius: 4,
              }}>
              {" "}
              <span> {expand ? `👇 ${explorer.name}` : `👉 ${explorer.name}`}</span>
              <button>➕</button>
            </div>
            <div>
              {explorer?.children?.map((exp) => (
                <div
                  key={exp.id}
                  style={{
                    display: `${expand ? "flex" : "none"}`,
                    paddingLeft: "16px",
                    cursor: "pointer",
                  }}>
                  <Folderss explorer={exp} />
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div
            title={explorer.name}
            style={{
              width: "120px",
              fontSize: "14px",
              cursor: "pointer",
              background: "gray",
              color: "white",
              margin: 4,
              padding: "4px",
              borderRadius: 4,
            }}
            onClick={(e) => {
              setImageListRef(ref(storage, `${explorer.name}/`));
              setCurrentFolder(`${explorer.name}`);
            }}>
            {" "}
            <span>📄 {explorer.name}</span>
          </div>
        )}
      </>
    );
  };

  const handleUpload = () => {
    if (uploadImage === null) {
      alert("Please select an image");
      return;
    }
    setUploadBtn(false);
    const imageRef = ref(storage, `${currentfolder}/${v4() + "_" + uploadImage.name}`);
    uploadBytes(imageRef, uploadImage).then((snapshot) => {
      getDownloadURL(snapshot.ref).then((url) => {
        getMetadata(snapshot.ref).then((data) => {
          const obj = {
            name: snapshot.ref.name,
            originalName: getFileName(snapshot.ref.name),
            fullPath: snapshot.ref.fullPath,
            parent: snapshot.ref.parent.name,
            root: snapshot.ref.root.name,
            link: url,
            size: data.size,
            created: data.timeCreated,
            updated: data.updated,
            contentType: data.contentType,
            item: snapshot.ref,
          };
          setImages((prev) => [...prev, obj]);
          alert("image uploaded");
          setUploadBtn(true);
          setUploadImage(null);
        });
      });
    });
  };

  useEffect(() => {
    if (currentfolder === "") {
      return;
    }
    setGalleryLoader(true);
    setImages([]);
    getAllImages(imageListRef, images).then((res) => {
      setImages(res);
      setGalleryLoader(false);
    });
    setGalleryLoader(false);

    // eslint-disable-next-line
  }, [imageListRef, currentfolder]);

  return (
    <div style={{ display: "grid", gridTemplateColumns: "180px 85%" }}>
      <div>
        <div style={{ position: "fixed", width: "fit-content" }}>
          <Folderss explorer={explorer} />
        </div>
      </div>

      {currentfolder !== "" ? (
        <div className="app__container">
          <div className="upload__file">
            <label htmlFor="upload-image" className="upload__label">
              {uploadImage ? uploadImage.name : "Choose Image"}
            </label>
            <input
              className="upload-image"
              id="upload-image"
              style={{ display: "none" }}
              type="file"
              onChange={(e) => setUploadImage(e.target.files[0])}
              title="Choose Image"
              aria-label="Choose Image"
            />
          </div>

          <div>
            {uploadBtn ? (
              <button className="button" onClick={handleUpload}>
                Uplaod Image
              </button>
            ) : (
              <button className="disButton">
                <Spinner color="#ffffff" size={20} type="BarLoader" />
              </button>
            )}
          </div>

          {!galleryLoader ? <Gallery images={images} /> : null}
        </div>
      ) : (
        <div className="app__container">Please select a file</div>
      )}
    </div>
  );
}

export default Home;
